import { TokenHistoryLabel } from "kadow-jetpack-model";
import stripParams from "./stripParams";

export function cleanSocialLinksByCTA(
  ctaId: TokenHistoryLabel,
  link:
    | string
    | {
        lat: number;
        lng: number;
      }
): string {
  if (typeof link === "string") {
    switch (ctaId) {
      case TokenHistoryLabel.Instagram:
      case TokenHistoryLabel.IGStory:
        return (link = stripParams(
          link
            .replaceAll("https://www.instagram.com/", "")
            .replaceAll("https://instagram.com/", "")
            .replaceAll("instagram.com/", "")
            .replaceAll("/", "")
            .replaceAll("@", "")
            .trim()
        ));

      case TokenHistoryLabel.Facebook:
        return (link = stripParams(
          link
            .replaceAll("https://www.facebook.com/", "")
            .replaceAll("https://facebook.com/", "")
            .replaceAll("facebook.com/", "")
            .replaceAll("/", "")
            .replaceAll("@", "")
            .trim()
        ));

      case TokenHistoryLabel.SnapChat:
        return (link = stripParams(
          link
            .replaceAll("https://www.snapchat.com/", "")
            .replaceAll("https://snapchat.com/", "")
            .replaceAll("snapchat.com/", "")
            .replaceAll("add/", "")
            .replaceAll("https://t.snapchat.com/", "")
            .replaceAll("https://story.snapchat.com/", "")
            .replaceAll("?share", "")
            .replaceAll("@", "")
            .replaceAll("/", "")
            .trim()
        ));

      case TokenHistoryLabel.TikTok:
        return (link = stripParams(
          link
            .replaceAll("https://www.tiktok.com/", "")
            .replaceAll("https://tiktok.com/", "")
            .replaceAll("/", "")
            .replaceAll("@", "")
            .trim()
        ));

      default:
        return link;
    }
  }
  return "";
}
